import { images } from '_/assets';
import { Text } from '_/components';
import { fontSizes, spacing } from '_/constants/theme';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { View, Image, StyleSheet } from 'react-native';

export default function NoReports() {
  const { t } = useTranslation();

  return (
    <View style={styles.container}>
      <Image source={images.denied} style={styles.image} />
      <Text fontSize={fontSizes.md2} style={styles.text}>
        {t('reportsScreen.noReportsMessage')}
      </Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 40,
  },
  image: {
    marginTop: 100,
    marginBottom: spacing.md,
  },
  text: {
    textAlign: 'center',
    maxWidth: '60%',
  },
});
